import sortBy from 'lodash/sortBy';
import type { Dispatch } from 'react';
import type { Reducer } from 'redux';

import type { SubmitStatus } from 'src/hooks/submit';
import {
  getListingStats as getStats,
  getAccountListings,
  postListing,
} from 'src/services/api';
import { noop, replaceById } from 'src/utils';
import { action } from 'src/utils/redux';
import type { ArrayElement } from 'src/utils/types';

import type { StoreProps } from '..';

export const actions = [
  // TODO: remove
  action('GET_LISTINGS_REQUEST' as const).payload<unknown>(),
  // TODO: remove
  action('GET_LISTINGS_SUCCESS' as const).payload<Listing[]>(),
  // TODO: remove
  action('GET_LISTINGS_FAIL' as const).payload<Listing[]>(),

  // TODO: remove
  action('GET_LISTINGS_STATS_REQUEST' as const).payload<unknown>(),
  // TODO: remove
  action('GET_LISTINGS_STATS_SUCCESS' as const).payload<StatsPayload>(),
  // TODO: remove
  action('GET_LISTINGS_STATS_FAIL' as const).payload<StatsPayload>(),

  action('POST_LISTING_REQUEST' as const).payload<unknown>(),
  action('POST_LISTING_SUCCESS' as const).payload<Listing>(),
  action('POST_LISTING_FAIL' as const).payload<Listing>(),

  action('EXPIRE_LISTING_REQUEST' as const).payload<unknown>(),
  action('EXPIRE_LISTING_SUCCESS' as const).payload<Listing>(),
  action('EXPIRE_LISTING_FAIL' as const).payload<Listing>(),
];
export type Action = ArrayElement<typeof actions>;

// TODO: remove
export const getListings =
  (clientId: string) => (dispatch: Dispatch<Action>) => {
    dispatch({
      type: 'GET_LISTINGS_REQUEST',
      payload: {},
    });
    return getAccountListings(clientId)
      .then((res: Listing[]) => {
        dispatch({
          type: 'GET_LISTINGS_SUCCESS',
          payload: sortBy(res, (l) => (l.status % 4) + l.createdDate).reverse(), // Put most relevant ads on top
        });
      })
      .catch((_: any) => {
        dispatch({
          type: 'GET_LISTINGS_FAIL',
          payload: [],
        });
      });
  };

// TODO: remove
export const getListingsFetchStatus =
  (state: StoreProps) => (fetchFunction: () => void) => {
    const hasLoaded = Boolean(state.fetchingFlags.getListingsComplete);
    const isFetching = Boolean(state.fetchingFlags.getListingsFetching);
    const wasFetched = hasLoaded && state.listings.loadedAccountListings;
    return {
      fetch: hasLoaded || isFetching ? noop : fetchFunction,
      hasLoaded,
      wasFetched,
    };
  };

// TODO: remove
export const getListingStats =
  (listingId: string) => (dispatch: Dispatch<Action>) => {
    dispatch({
      type: 'GET_LISTINGS_STATS_REQUEST',
      payload: {},
    });
    return getStats(listingId)
      .then((stats) => {
        dispatch({
          type: 'GET_LISTINGS_STATS_SUCCESS',
          payload: { stats },
        });
      })
      .catch((err) => {
        dispatch({
          type: 'GET_LISTINGS_STATS_FAIL',
          payload: err,
        });
      });
  };

// TODO: remove
export const getListingsStatsStatus =
  (state: StoreProps) => (fetchFunction: () => void) => {
    const hasLoaded = Boolean(state.fetchingFlags.getListingsStatsComplete);
    const isFetching = Boolean(state.fetchingFlags.getListingsStatsFetching);
    const wasFetched = hasLoaded && state.listings.loadedAccountListings;
    return {
      fetch: hasLoaded || isFetching ? noop : fetchFunction,
      hasLoaded,
      wasFetched,
    };
  };

// TODO: this is deprecated in favour of the GraphQL "postListing" mutation
// This will be removed once all consumers are ported
// TODO: remove
export const dispatchListingPostRequest =
  (setFormStatus: (status: SubmitStatus) => void, listingId: string) =>
  (dispatch: Dispatch<Action>) => {
    dispatch({
      type: 'POST_LISTING_REQUEST',
      payload: {},
    });
    setFormStatus({ status: 'LOADING' });
    return postListing(listingId)
      .then((updated) => {
        dispatch({
          type: 'POST_LISTING_SUCCESS',
          payload: updated,
        });
        setFormStatus({
          status: 'SUCCESS',
          data: { message: 'You successfully posted your ad' },
        });
      })
      .catch((err) => {
        dispatch({
          type: 'POST_LISTING_FAIL',
          payload: err,
        });
        setFormStatus({
          status: 'FAIL',
          data: { message: err.errorMessage, ...err },
        });
      });
  };

// TODO: remove
export interface Listing {
  isPremium: boolean;
  productCode: string;
  images: string[];
  listingID: number;
  details: string;
  investmentAmount: number;
  investmentRangeMin?: number;
  investmentRangeMax?: number;
  investmentNegotiable: boolean;
  investmentPOA: boolean;
  inventoryAmount?: number;
  inventoryRangeMin?: number;
  inventoryRangeMax?: number;
  inventorySAV: boolean;
  mainImageUrl: string;
  clientId: number;
  opportunityId: number;
  title: string;
  industryId: number;
  locationTypeId: number;
  regionId: number;
  createdDate: string;
  pendingDate: string;
  activeDate: string;
  activeDateOriginal: string;
  expiryDate: string;
  isDeleted: boolean;
  status: number;
  stats?: ListingStats;
  loadedListingData?: boolean;
  autoRenew: boolean;
  creditRemaining: number;
}

// TODO: remove
export interface ListingStats {
  listingId: number;
  enquiryCount: number;
  listingCount: number;
  searchCount: number;
  contactCount: number;
}

const reducer: Reducer<Listings, Action> = (
  state = { listings: [], loadedAccountListings: false },
  act,
) => {
  switch (act.type) {
    // TODO: remove
    case 'GET_LISTINGS_STATS_SUCCESS':
      return {
        ...state,
        loadedAccountListings: true,
        listings: state.listings.map((val) => {
          if (val.listingID === act.payload.stats.listingId) {
            return { ...val, stats: act.payload.stats };
          }
          return val;
        }),
      };
    // TODO: remove
    case 'GET_LISTINGS_STATS_FAIL':
      return state;

    // TODO: remove
    case 'GET_LISTINGS_SUCCESS':
      return {
        ...state,
        loadedAccountListings: true,
        listings: act.payload,
      };
    case 'GET_LISTINGS_FAIL':
      return state;

    case 'POST_LISTING_SUCCESS':
      return {
        ...state,
        listings: replaceById(state.listings, act.payload, 'listingID'),
      };
    case 'POST_LISTING_FAIL':
      return state;

    case 'EXPIRE_LISTING_SUCCESS':
      return {
        ...state,
        listings: replaceById(state.listings, act.payload, 'listingID'),
      };
    case 'EXPIRE_LISTING_FAIL':
      return state;
    default:
      return state;
  }
};

export default reducer;

export interface Listings {
  // TODO: remove
  loadedAccountListings: boolean;
  listings: Listing[];
}

// TODO: remove
export interface StatsPayload {
  stats: ListingStats;
}
